import { render, staticRenderFns } from "./PoiListSearch.vue?vue&type=template&id=2aa89bc6&scoped=true&"
import script from "./PoiListSearch.vue?vue&type=script&lang=js&"
export * from "./PoiListSearch.vue?vue&type=script&lang=js&"
import style0 from "./PoiListSearch.vue?vue&type=style&index=0&id=2aa89bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa89bc6",
  null
  
)

export default component.exports